/* Product templates: gallery, format + option chips driven by real variant data, purchase type,
   accordion, sticky buy bar, gift card recipient, and the "More coffees" carousel. */
(function () {
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function money(c) { return "$" + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }

  /* ---- gallery ---- */
  var mainImg = $(".gallery-main-image");
  function showImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute("srcset"); mainImg.removeAttribute("sizes"); mainImg.src = src;
    $$("[data-thumb]").forEach(function (t) { t.classList.toggle("thumb--active", t.dataset.src === src); });
  }
  $$("[data-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      $$("[data-thumb]").forEach(function (o) { o.classList.remove("thumb--active"); });
      t.classList.add("thumb--active");
      if (mainImg) { mainImg.removeAttribute("srcset"); mainImg.removeAttribute("sizes"); mainImg.src = t.dataset.src; }
    });
  });

  /* ---- accordion ---- */
  $$("[data-acc]").forEach(function (t) {
    t.addEventListener("click", function () {
      var open = t.getAttribute("aria-expanded") !== "true";
      t.setAttribute("aria-expanded", String(open));
      t.parentElement.querySelector(".acc-panel").classList.toggle("acc-panel--open", open);
    });
  });

  /* ---- sticky buy bar: appears once the main Add to cart has scrolled past the top ---- */
  var anchor = $(".buy-actions"), bar = $("[data-sticky]");
  if (anchor && bar) {
    var sync = function () { bar.classList.toggle("sticky-buy--on", anchor.getBoundingClientRect().bottom < 0); };
    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  /* ---- variants ---- */
  var root = $("[data-product-root]");
  var jsonEl = root && $("script[data-product-json]", root);
  if (root && jsonEl) {
    var D = JSON.parse(jsonEl.textContent);
    var V = D.variants;
    var input = $("[data-variant-input]", root);
    var planInput = $("[data-selling-plan-input]", root);
    var format = D.currentFormat || "bean";
    var current = V.filter(function (v) { return String(v.id) === String(input && input.value); })[0] || V[0];
    var sel = current.options.slice();
    var plan = "once";

    function unitFor(size) {
      var out = "";
      (D.units || []).forEach(function (u) { var p = u.split("|"); if (p.length > 1 && size.indexOf(p[0].trim()) > -1 && !out) out = p[1].trim(); });
      return out;
    }
    function clean(s) { return String(s).replace(" (Green Coffee)", "").replace(".00", ""); }
    function find() {
      var pool = D.simple ? V : V.filter(function (v) { return v.format === format || D.isSingleFormat; });
      var exact = pool.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
      return exact || pool.filter(function (v) { return v.available; })[0] || pool[0];
    }
    function paint(v) {
      current = v; sel = v.options.slice();
      if (input) input.value = v.id;
      $$("[data-option]", root).forEach(function (b) {
        var on = sel[+b.dataset.option] === b.dataset.value;
        b.setAttribute("aria-pressed", String(on));
        if (b.classList.contains("option-chip")) b.classList.toggle("option-chip--active", on);
        if (!D.simple && !D.isSingleFormat && b.dataset.formats) b.hidden = b.dataset.formats.split(" ").indexOf(format) < 0;
      });
      $$("[data-option-group]", root).forEach(function (g) {
        var val = $("[data-option-value]", g); if (val) val.textContent = clean(sel[+g.dataset.optionGroup]);
        if (!D.simple && !D.isSingleFormat) g.hidden = !$$("[data-option]", g).some(function (b) { return !b.hidden; });
      });
      $$("[data-format]", root).forEach(function (b) {
        var on = b.dataset.format === format;
        b.classList.toggle("option-chip--active", on); b.setAttribute("aria-pressed", String(on));
      });
      var fv = $("[data-format-value]", root); if (fv) fv.textContent = { bean: "Whole bean", green: "Green", capsules: "Capsules", instant: "Instant" }[format] || "";
      var fn = $("[data-format-note]", root); if (fn && D.notes) fn.textContent = D.notes[format] || "";
      var pur = $("[data-purchase]", root); if (pur) pur.hidden = format !== "bean";
      if (format !== "bean" && plan !== "once") setPlan("once");

      var price = $("[data-price]"); if (price) price.textContent = v.available ? money(v.price) : "Sold out";
      var size = clean(v.options[v.options.length - 1]);
      var unit = $("[data-unit]");
      if (unit && !D.simple) { var u = unitFor(size); unit.innerHTML = (D.isSingleFormat ? unit.textContent : size + (u ? " &middot; " + u : "")); }
      var sp = $("[data-sticky-price]");
      if (sp) sp.innerHTML = money(v.price) + " &middot; " + (format === "green" ? "Green, " : "") + size;
      $$("[data-add]").forEach(function (a) {
        a.disabled = !v.available; a.classList.toggle("is-soldout", !v.available);
        var l = $(".button-label", a); if (l) l.textContent = v.available ? "Add to cart" : (D.soldoutLabel || "Sold out");
      });
      if (v.image) showImage(v.image);
      if (history.replaceState) { var u2 = new URL(location.href); u2.searchParams.set("variant", v.id); history.replaceState(null, "", u2.toString()); }
      if (planInput) planInput.value = plan !== "once" ? (v.plan || plan) : "";
    }
    function setPlan(p) {
      plan = p;
      $$("button[data-plan]", root).forEach(function (b) {
        var on = b.dataset.plan === p; b.classList.toggle("plan-option--active", on); b.setAttribute("aria-pressed", String(on));
      });
      if (planInput) planInput.value = p !== "once" ? (current.plan || p) : "";
    }
    root.addEventListener("click", function (e) {
      var f = e.target.closest("button[data-format]");
      if (f) { format = f.dataset.format; var first = V.filter(function (v) { return v.format === format && v.available; })[0] || V.filter(function (v) { return v.format === format; })[0]; if (first) paint(first); return; }
      var o = e.target.closest("[data-option]");
      if (o) { sel[+o.dataset.option] = o.dataset.value; paint(find()); return; }
      var pl = e.target.closest("button[data-plan]");
      if (pl) { setPlan(pl.dataset.plan); }
    });
    paint(current);
  }

  /* ---- gift card: only send to a recipient when an email is given ---- */
  var gift = $("[data-gift-fields]");
  if (gift) {
    var form = gift.closest("form");
    form.addEventListener("submit", function () {
      var email = $("[data-gift-email]", gift), flag = $("[data-gift-flag]", form);
      var on = !!(email && email.value.trim());
      if (flag) flag.disabled = !on;
      $$("input, textarea", gift).forEach(function (f) { f.disabled = !on; });
      setTimeout(function () { $$("input, textarea", gift).forEach(function (f) { f.disabled = false; }); }, 0);
    });
  }

  /* ---- "More coffees" carousel: arrows + progress (same behaviour as the homepage fast lane) ---- */
  $$(".section--related").forEach(function (section) {
    var track = $(".carousel-track", section), bar = $(".carousel-progress-bar", section);
    var prev = $(".carousel-button--prev", section), next = $(".carousel-button--next", section);
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (bar) {
        bar.style.width = Math.min(100, ratio * 100) + "%";
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = "translateX(" + (pos * (1 / Math.max(ratio, .0001) - 1) * 100) + "%)";
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    function step(dir) { var c = $(".product-card", track); if (c) track.scrollBy({ left: dir * (c.offsetWidth + 24) * 2, behavior: "smooth" }); }
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
})();
